<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
-->
<!-- IP-NOTICE: MIXED -->
<form id="organiserCreate" [formGroup]="dataForm" (ngSubmit)="onSubmitOrganiserCreate()" novalidate>

	<div class="flex-layout-row flex-layout-gap-10px">
		<button class="submitBtn" mat-raised-button type="submit" color="primary">Create</button>
		<!--<button mat-raised-button (click)="save()" color="primary">Create</button>-->
		<button mat-raised-button (click)="onCancel($event)">Cancel</button>
	</div>

	<div class="overflowScroller">
		<div>
			<mat-form-field>
				<mat-label>First Name</mat-label><input formControlName="firstNames" matInput />
				<mat-error *ngIf="firstNames.touched && firstNames.errors?.required"> First Name is required </mat-error>
				<mat-error *ngIf="firstNames.touched && firstNames.errors?.maxlength">First Name must be no more than 50 characters</mat-error>
				<mat-error *ngIf="firstNames.touched && firstNames.errors?.pattern && !firstNames.errors?.maxlength">First Name must be a correctly formatted person's name</mat-error>
			</mat-form-field>
		</div>
		<div>
			<mat-form-field>
				<mat-label>Last Name</mat-label><input formControlName="lastName" matInput />
				<mat-error *ngIf="lastName.touched && lastName.errors?.required"> Last Name is required </mat-error>
				<mat-error *ngIf="lastName.touched && lastName.errors?.maxlength">Last Name must be no more than 50 characters</mat-error>
				<mat-error *ngIf="lastName.touched && lastName.errors?.pattern && !lastName.errors?.maxlength">Last Name must be a correctly formatted person's name</mat-error>
			</mat-form-field>
		</div>
		<div>
			<mat-form-field>
				<mat-label>Organisation</mat-label><input formControlName="organisation" matInput />
				<mat-error *ngIf="organisation.touched && organisation.errors?.required"> Organisation is required </mat-error>
				<mat-error *ngIf="organisation.touched && organisation.errors?.maxlength">Organisation must be no more than 200 characters</mat-error>
			</mat-form-field>
		</div>
		<div>
			<mat-form-field>
				<mat-label>Email</mat-label><input formControlName="email" matInput autocomplete="disable-important" />
				<mat-error *ngIf="email.touched && email.errors?.required"> Email is required </mat-error>
				<mat-error *ngIf="email.touched && email.errors?.maxlength">Email must be no more than 254 characters</mat-error>
				<mat-error *ngIf="email.touched && email.errors?.pattern && !email.errors?.maxlength">Email must be a correctly formatted email address</mat-error>
				<mat-error *ngIf="email.touched && email.errors?.notUnique && !(email.errors?.maxlength || email.errors?.pattern)"> Email already exists on a User Account, try a different Email Address</mat-error>
			</mat-form-field>
		</div>
		<div>
			<mat-form-field>
				<mat-label>Telephone</mat-label><input formControlName="phone" matInput />
				<mat-error *ngIf="phone.touched && phone.errors?.required"> Telephone is required </mat-error>
				<mat-error *ngIf="phone.touched && phone.errors?.maxlength">Telephone must be no more than 15 characters</mat-error>
				<mat-error *ngIf="phone.touched && phone.errors?.pattern && !phone.errors?.maxlength">Telephone must be a correctly formatted mobile phone number</mat-error>
				<mat-error *ngIf="phone.touched && phone.errors?.notUnique && !(phone.errors?.maxlength)"> Telephone already exists on a User Account, try a different Telephone Number</mat-error>
			</mat-form-field>
		</div>
		<div>
			<mat-form-field>
				<mat-label>Password</mat-label>
				<input [type]="hidePassword ? 'password' : 'text'" formControlName="password" matInput autocomplete="new-password" (change)="passwordFieldChanged()"/>
				<button mat-icon-button matSuffix (click)="hidePassword = !hidePassword">
					<mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
				</button>
				<mat-error *ngIf="password.touched && password.errors?.required">
					Password is required
				</mat-error>
				<mat-error *ngIf="password.touched && (password.errors?.pattern || password.errors?.minlength) && !password.errors?.maxlength">
					Password must be at least 8 characters, including a number and a special character
				</mat-error>
				<mat-error *ngIf="password.touched && password.errors?.maxlength">
					Password must be no more than 12 characters
				</mat-error>
			</mat-form-field>
		</div>
		<div>
			<mat-form-field>
				<mat-label>Confirm Password</mat-label>
				<input [type]="hidePassword ? 'password' : 'text'" formControlName="confirmPassword" matInput />
				<mat-error *ngIf="confirmPassword.touched && confirmPassword.errors?.required">
					Confirm Password is required
				</mat-error>
				<mat-error *ngIf="confirmPassword.errors?.passwordMismatch && !confirmPassword.errors?.maxlength">
					Confirm Password must match Password
				</mat-error>
				<mat-error *ngIf="confirmPassword.touched && confirmPassword.errors?.maxlength">
					Confirm Password must be no more than 12 characters
				</mat-error>
			</mat-form-field>
		</div>

		<div>
			<re-captcha formControlName="recaptcha" [siteKey]="recaptchaSiteKey" required/>
			<mat-error *ngIf="recaptcha.touched && recaptcha.errors?.required"> I'm not a robot must be checked </mat-error>
		</div>

		<div>
			<mat-checkbox formControlName="termsAndPrivacy">
				I agree to the <a [href]="termsUrl" target="_blank">Terms</a> and <a [href]="privacyPolicyUrl" target="_blank">Privacy Policy</a>
			</mat-checkbox>
			<mat-error *ngIf="termsAndPrivacy.touched && termsAndPrivacy.errors?.required"> I agree to the Terms and Privacy Policy must be checked </mat-error>
		</div>


	</div>

</form>
